<script setup lang="ts">
import type { ValidationState } from 'bootstrap-vue-next';
import { BButton, BCard, BForm, BFormGroup, BFormInput } from 'bootstrap-vue-next';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { parseGitLabIssueUrl } from '~/common/IssueUrlRegexUtils';
import { useGitlabHostname } from '~/common/useGitlabHostname';

const gitlabHostname = useGitlabHostname();
const issueUrl = ref<string | null>(null);
const valid = ref<ValidationState>(null);
const router = useRouter();

const loadIssue = () => {
  const parsedUrl = parseGitLabIssueUrl(issueUrl.value, gitlabHostname);
  if (!parsedUrl) {
    valid.value = false;

    return;
  }

  void router.push({ query: { projectPath: parsedUrl.projectPath, issueIid: parsedUrl.iid } });
};
</script>

<template>
  <BCard>
    <BForm @submit.prevent="loadIssue">
      <BFormGroup
        label="Issue URL"
        class="mb-3"
        :state="valid"
        invalid-feedback="Not a valid issue URL"
      >
        <div class="d-flex gap-3">
          <BFormInput
            v-model="issueUrl"
            required
            autofocus
          />
          <BButton
            type="submit"
            variant="primary"
            class="text-nowrap"
          >
            Lookup issue
          </BButton>
        </div>
      </BFormGroup>
    </BForm>
  </BCard>
</template>
